import { ITeacher } from '~/types/teacher'
import http from '~/utils/http'

/** 获取所有老师 */
export function getAllTeacher(page: number, size: number) {
  return http.get('/admin/teacher', {
    params: {
      page,
      size,
    },
  })
}

/** 新增老师 */
export function postTeacher(data: Partial<ITeacher>) {
  return http.post('/admin/teacher', data)
}

/** 删除老师 */
export function deleteTeacher(userId: string) {
  return http.delete(`/admin/teacher/${userId}`)
}

/** 编辑老师 */
export function patchTeacher(userId: string, data: Partial<ITeacher>) {
  return http.patch(`/admin/teacher/${userId}`, data)
}

/** 设置老师在岗状态，不影响已有预约和账号 */
export function updateTeacherDuty(teacherId: string, onDuty: boolean) {
  return http.patch(`/admin/teacher/${teacherId}/duty`, { onDuty })
}
